import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Finance.ClaimJobPayment.Find.IRequest;
type Response = Api.Finance.ClaimJobPayment.Find.IResponse;
type Headers = Api.Finance.ClaimJobPayment.Find.IHeaders;
const url = '/api/Finance/ClaimJobPayment/:id';
export default async function claimJobPaymentFindApi(params: { id: number }): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url: createPathFromRoute(url, params),
    headers: getDefaultHeaders(),
  });
}
